import IconLegalScales from '@/components/icons/legalScales.vue'
import IconCashSearch from '@/components/icons/cashSearch.vue'
import IconCheck from '@/components/icons/check.vue'
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconStar from '@/components/icons/star.vue'
import IconInformation from '@/components/icons/information.vue'
import IconRefresh from '@/components/icons/refresh.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'

export default {
    name: "ChooseYourRole",
    components: {
        IconCheck,
        IconBase,
        IconLegalScales,
        IconCashSearch,
        IconArrowBack,
        IconForwardBack,
        IconStar,
        IconInformation,
        IconRefresh,
        BackButton,
        NextButton
    },
    data() {
        return {
            additional_cover: [],
            acover1_price: '$110',
            acover2_price: '$90',
            dialog_addons: false
        }
    },
    methods: {
        SelectAdditionalCover(_element, _additionalCover) {
            var n = this.additional_cover.indexOf(_additionalCover);
            if(n > -1){  
                this.additional_cover.splice(n, 1);               
            }else{
                this.additional_cover.push(_additionalCover);
            };
            
            this.$parent.EducatorInsuranceProcess.additional_cover = this.additional_cover;
            var check_element = _element + '_check';
            var check_price = _element + '_price';
            document.getElementById(_element).classList.toggle("selected");//icon_added_show
            document.getElementById(check_element).classList.toggle("show");
            document.getElementById(check_element).classList.toggle("hide");
            

            var added_check_element = _element + '_added';
            document.getElementById(added_check_element).classList.toggle("hide");
            document.getElementById(added_check_element).classList.toggle("show");
            document.getElementById(check_price).classList.toggle("hide");

            this.CheckAdditionCoverLength(this.additional_cover , check_price);

        }, 
        Next() {
            this.$parent.EducatorInsuranceProcess = Globals.CreateLocalData(this.$parent.Role);
            if(this.additional_cover != "") {
               if(this.additional_cover.length == 2){
                    this.$parent.EducatorInsuranceProcess.breakdown.additional_cover_total = "163.90";
               }else if(this.additional_cover.length == 1){
                    if(this.additional_cover.indexOf('Telephone Legal Advice') > -1){
                        this.$parent.EducatorInsuranceProcess.breakdown.additional_cover_total = "97.90";
                    }else{
                        this.$parent.EducatorInsuranceProcess.breakdown.additional_cover_total = "110.00";
                    }
                    
               }else{
                    this.$parent.EducatorInsuranceProcess.breakdown.additional_cover_total = 0
               }
               this.$parent.EducatorNextStep(12,"EducatorFinalQuote"); 
            } 
        },
        ValidateSessionData() {
          let _data = this.$parent.EducatorInsuranceProcess;
          if((_data.additional_cover != null) || (_data.additional_cover != undefined)) {
            this.additional_cover = _data.additional_cover;
            if(_data.additional_cover.length > 0) {
                _data.additional_cover.forEach(function(_item) {
                    if(_item === "Legal Advice") {
                       document.getElementById("acover1").classList.add("selected");
                       document.getElementById("acover1_added").classList.add("show");
                       document.getElementById("acover1_check").classList.add("show");
                       document.getElementById("acover1_added").classList.remove("hide");
                       document.getElementById("acover1_check").classList.remove("hide");
                       document.getElementById("acover1_price").classList.add("hide");
                    } else if (_item === "Debt recovery service") {
                       document.getElementById("acover2").classList.add("selected");
                       document.getElementById("acover2_added").classList.add("show");
                       document.getElementById("acover2_check").classList.add("show");
                       document.getElementById("acover2_added").classList.remove("hide");
                       document.getElementById("acover2_check").classList.remove("hide");
                       document.getElementById("acover2_price").classList.add("hide");
                    }
                });
            } 
          } 
        },
        clickModal(){
            this.dialog_addons = true;
        },
        CheckAdditionCoverLength(_additionalCover, _element){
            var ac_length = this.additional_cover.length;

            //for mounted
            if(_element == ''){
                if(this.additional_cover[0] == 'Debt recovery service'){
                    _element = 'acover2_price';
                }else{
                    _element = 'acover1_price';
                }
            }
            

            if(ac_length <= 0){
                this.acover1_price = '$110';
                this.acover2_price = '$90';
            }else{
                if(_element == 'acover1_price'){
                    this.acover2_price = '$71.82';
                    
                }else{
                    this.acover1_price = '$91.82';
                    
                }
            }
        },
        disableModal(){
            this.dialog_addons = false;        
        }
       
    },
    computed: {
        AllFieldsValid: function() {
            var _isvalid = false;
            if(this.additional_cover.length > 0) {
                _isvalid = true;
            }
            return _isvalid;
        },
        dialog_addons: function (newVal, oldVal) {
            if(this.dialog_addons == false){
                document.getElementById("modify_overlay2").classList.remove("v-overlay--active");
                this.$parent.overlay = false;
                //this.$parent.header_like_enabled = false;
            }else{
               document.getElementById("modify_overlay2").classList.add("v-overlay--active");
                this.$parent.overlay = true;
                //his.$parent.header_like_enabled = true;
            }
        }
    },
    watch: {
        overlay: function (newVal, oldVal) {
            if(newVal == false){
                document.getElementById("modify_overlay2").classList.remove("v-overlay--active");
                this.dialog_addons = false;
            }else{
               document.getElementById("modify_overlay2").classList.add("v-overlay--active");
               this.dialog_addons = true;
            }
        }
    },
    mounted(){
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
        this.CheckAdditionCoverLength(this.$parent.EducatorInsuranceProcess.additional_cover, '');

        
    },
}